export enum AnalyticsSteps {
  Who = 'Trip Details - Traveller Details',
  Where = 'Trip Details - Destination Selection',
  When = 'Trip Details - Date Selection',
  Mandatory = 'Core plan',
  Optional = 'Optional Covers',
  Activity = 'Activity Covers',
  Traveller = 'Traveller Details',
  Health = 'Health Screening',
  Medical = 'Medical Assessment',
  Delivery = 'Delivery Address',
  Payment = 'Payment Screen',
  Success = 'Success Screen'
}

export const AnalyticsStepsOrder = {
  [AnalyticsSteps.Mandatory]: 1,
  [AnalyticsSteps.Optional]: 2,
  [AnalyticsSteps.Activity]: 3,
  [AnalyticsSteps.Traveller]: 4,
  [AnalyticsSteps.Health]: 5,
  [AnalyticsSteps.Medical]: 6,
  [AnalyticsSteps.Delivery]: 7,
  [AnalyticsSteps.Payment]: 8,
  [AnalyticsSteps.Success]: 9
};

export enum AnalyticsActions {
  Add = 'Add',
  Edit = 'Edit',
  Remove = 'Remove',
  Delete = 'Delete',
  Continue = 'Continue',
  InsuredAmountChange = 'Cancellation Cover Change',
  ExcessChange = 'Excess Amount Change'
}

export enum AnalyticsMedicalTypes {
  Quote = 'Quote',
  PreEx = 'PreEx',
  PreExFree = 'PreExFree',
  PreExCharge = 'PreExCharge',
  Refer = 'Refer'
}
